import { find } from 'lodash';
import { Component, OnInit, Input, ViewChildren, QueryList, AfterViewInit, ViewChild } from '@angular/core';
import {
  Tarea, TareaFinalizacion, TareaOpcionAdmin, ConfirmComponent, Static, TypeProcess
} from '@app/shared';
import { Logger } from '@app/core';
import { FlowOrigin } from '../shared';
import { ManageCompletionComponent } from '../manage-completion/manage-completion.component';
import { ScrollToService, ScrollToConfigOptions } from '@nicky-lenaers/ngx-scroll-to';

type Action = 'remove';

const log: Logger = new Logger();

@Component({
  selector: 'iw-refactoring-completions',
  templateUrl: './refactoring-completions.component.html',
  styleUrls: ['./refactoring-completions.component.scss']
})
export class RefactoringCompletionsComponent implements OnInit, AfterViewInit {
  // Contiene el tipo de proceso que se esta renderizando
  @Input() typeProcess: TypeProcess;
  // Indice de la condición que esta renderizando el componente.
  @Input() indexCondition: number;
  // Numero de pregunta
  @Input() numberQuestion: number;
  // Tarea actual, con la que se esta trabajando (origen)
  @Input() sourceTaskI: Tarea;
  sourceTask: Tarea;
  // Origen del flujo
  @Input() origin: FlowOrigin;
  // Estas propiedad aplica solo para las tareas con condiciones:
  // Opción con la que se esta trabajando.
  @Input() option: TareaOpcionAdmin;
  // Obtiene las asociaciones de la tarea
  @Input()
  set listAssociations (list: any[]) {
    this._listAssociations = list;
  }
  // Define la pregunta del componente de confirmacion
  question = '';
  // Index de la finalizacion seleccionada
  indexCompletionSelect = -1;
  // Define la accion a realizar
  action: Action;
  // Componente que gestiona las finalizacion de la tarea
  @ViewChildren(ManageCompletionComponent) manageCompletionsRef: QueryList<ManageCompletionComponent>;
  // Contiene las asociaciones de la tarea actual
  private _listAssociations: any[] = [];
  // Referencia al componente de confirmación
  @ViewChild('confirmAction') private confirmAction: ConfirmComponent;

  constructor(
    private sts: ScrollToService,
  ) { }

  ngOnInit() {
    if (this.sourceTaskI) {
      this.sourceTask = Static.copyObjet(this.sourceTaskI);
    } else {
      this.sourceTask = Static.copyObjet({}) as Tarea;
    }
    if (this.sourceTask && (!this.sourceTask.tarea_finalizacion || !this.sourceTask.tarea_finalizacion.length)) {
      if (!this.sourceTask.tarea_finalizacion) {
        this.sourceTask['tarea_finalizacion'] = [];
      }
      this.sourceTask.tarea_finalizacion.push({
        tarea_inicio: this.sourceTask.id,
        tarea_destino: 0,
        parametros: {
          finalizacion: true
        },
        tipo_finalizacion: null,
        opcion: this.option ? this.option.id_opcion ? this.option.id_opcion : 0 : 0,
      });
    }
    if (this.option && this.option.id_opcion) {
      const completion = find(this.sourceTask.tarea_finalizacion, {opcion: this.option.id_opcion});
      if (!completion) {
        this.sourceTask.tarea_finalizacion.push({
          tarea_inicio: this.sourceTask.id,
          tarea_destino: 0,
          parametros: {
            finalizacion: true
          },
          tipo_finalizacion: null,
          opcion: this.option.id_opcion
        });
      }
    }
  }

  ngAfterViewInit () {
    this.manageCompletionsRef.changes.subscribe((items: Array<ManageCompletionComponent>) => {
      log.debug(this.manageCompletionsRef);
    });
  }

  get listAssociations (): any[] {
    return this._listAssociations;
  }

  /**
   * Validad que toda la informacion de las finalizaciones este completa
   *
   * @returns {boolean}
   * @memberof RefactoringCompletionsComponent
   */
  isValidData(): boolean {
    let valid = false;
    if (this.sourceTask && this.sourceTask.tarea_finalizacion && this.sourceTask.tarea_finalizacion.length) {
      for (let index = 0; index < this.sourceTask.tarea_finalizacion.length; index++) {
        if (this.manageCompletionsRef && this.manageCompletionsRef.length) {
          this.manageCompletionsRef.forEach(completion => {
            if (!this.option && completion.indexCompletion === index ) {
              valid = completion.isValidData();
            }
            if (this.option && completion.option.id_opcion === this.option.id_opcion) {
              valid = completion.isValidData();
            }
          });
          if (!valid) {
            break;
          }
        } else {
          valid = false;
          break;
        }
      }
    }
    return valid;
  }

  /**
   * Obtener lista de todas las finalizaciones
   *
   * @returns {TareaFinalizacion[]}
   * @memberof RefactoringCompletionsComponent
   */
  getCompletion(): TareaFinalizacion[] {
    const completionsFinish: TareaFinalizacion[] = [];
      if (this.isValidData()) {
        if (this.sourceTask && this.sourceTask.tarea_finalizacion && this.sourceTask.tarea_finalizacion.length) {
          for (let index = 0; index < this.sourceTask.tarea_finalizacion.length; index++) {
            if (this.manageCompletionsRef && this.manageCompletionsRef.length) {
              this.manageCompletionsRef.forEach(completion => {
                if (completion.indexCompletion === index) {
                  const completionFinish = completion.getCompletion();
                  completionFinish.opcion = this.option ? this.option.id_opcion ? this.option.id_opcion : 0 : 0;
                  completionsFinish.push(completionFinish);
                }
              });
            } else {
              break;
            }
          }
        }
      }
    return completionsFinish;
  }

  /**
   * Limpiar todos los formularios de las finalizaciones
   *
   * @memberof RefactoringCompletionsComponent
   */
  empty() {
    this.manageCompletionsRef.forEach(completion => {
      completion.empty();
    });
  }

  /**
   * Agregar finalización
   *
   * @memberof RefactoringCompletionsComponent
   */
  addCompletion() {
    if (this.sourceTask && this.sourceTask.tarea_finalizacion && this.sourceTask.tarea_finalizacion.length) {
      this.sourceTask.tarea_finalizacion.push({
        tarea_inicio: this.sourceTask.id,
        tarea_destino: 0,
        parametros: {
          finalizacion: true
        },
        tipo_finalizacion: null,
        opcion: this.option ? this.option.id_opcion ? this.option.id_opcion : 0 : 0,
      });
      setTimeout(() => {
        let target = '';
        if (this.option) {
          target = 'completion_' + this.option.id_opcion + '_' + (this.sourceTask.tarea_finalizacion.length - 1);
        } else {
          target = 'completion_' + (this.sourceTask.tarea_finalizacion.length - 1);
        }
        this.sts.scrollTo({
          target: target
        } as ScrollToConfigOptions);
      });
    }
  }

  /**
   * Ejecuta una accion especifica con confirmacion
   *
   * @param {Action} action
   * @param {*} [data]
   * @memberof RefactoringCompletionsComponent
   */
  runAction(action: Action, data?: any) {
    this.action = action;
    switch (action) {
      case 'remove':
        this.question = '¿Realmente desea eliminar la finalización?';
        this.indexCompletionSelect = data;
        break;
    }
    this.confirmAction.open();
  }

  /**
   * Controla la respuesta de confirmacion
   *
   * @param {boolean} resp
   * @memberof RefactoringCompletionsComponent
   */
  actionComfirm(resp: boolean) {
    if (resp) {
      switch (this.action) {
        case 'remove':
          this.removeCompletion();
          this.action = null;
          break;
      }
    }
  }

  /**
   * Elimina la finalizacion seleccionada
   *
   * @private
   * @memberof RefactoringCompletionsComponent
   */
  private removeCompletion() {
    if (
      this.sourceTask &&
      this.sourceTask.tarea_finalizacion &&
      this.sourceTask.tarea_finalizacion.length &&
      this.indexCompletionSelect >= 0
    ) {
      this.sourceTask.tarea_finalizacion.splice(this.indexCompletionSelect, 1);
      let indexScroll = 0;
      if (this.indexCompletionSelect > 0) {
        indexScroll = this.indexCompletionSelect - 1;
      }
      setTimeout(() => {
        let target = '';
        if (this.option) {
          target = 'completion_' + this.option.id_opcion + '_' + indexScroll;
        } else {
          target = 'completion_' + indexScroll;
        }
        this.sts.scrollTo({
          target: target
        } as ScrollToConfigOptions);
      });
      this.indexCompletionSelect = -1;
    }
  }

}



// WEBPACK FOOTER //
// ./src/app/administration/process-automation/refactoring-completions/refactoring-completions.component.ts